import React, { FC, memo } from 'react';
import { Circle, Line, Text } from 'react-konva';
import { roundNumber } from 'shared/utils/helpers/roundNumber';
import { Point } from '../utils/helpers/coordinates';

interface BackgroundScaleMeasurePreviewProps {
  start: Point | null;
  end: Point | null;
  canvasScale: number;
}

export const BackgroundScaleMeasurePreview: FC<BackgroundScaleMeasurePreviewProps> = memo(({ start, end, canvasScale }) => {
  if (!start || !end) return null;

  const strokeWidth = 2 / canvasScale;
  const radius = 4 / canvasScale;
  const measuredPixels = Math.hypot(end.x - start.x, end.y - start.y);

  return (
    <>
      <Line points={[start.x, start.y, end.x, end.y]} stroke="#ff4fd8" strokeWidth={strokeWidth} listening={false} />
      <Circle x={start.x} y={start.y} radius={radius} fill="#ff4fd8" listening={false} />
      <Circle x={end.x} y={end.y} radius={radius} fill="#ff4fd8" listening={false} />
      <Text
        x={(start.x + end.x) / 2 + 8 / canvasScale}
        y={(start.y + end.y) / 2 + 8 / canvasScale}
        text={`${roundNumber(measuredPixels, 1)} px`}
        fontSize={12 / canvasScale}
        fill="#ff4fd8"
        listening={false}
      />
    </>
  );
});
